<template>
  <div class="i-datetime-picker">
    <el-date-picker
      ref="datetimePickerRef"
      v-model="inputVal"
      :type="type"
      :format="format"
      :value-format="valueFormat"
      :placeholder="placeholder"
      range-separator="to"
      unlink-panels
      :clearable="clearable"
      :disabled="disabled"
      :picker-options="pickerOptions"
      :default-time="defaultTime"
      size="small"
      class="date-picker"
      @input.native="inputValue"
    />
  </div>
</template>
<script>
export default {
  name: 'DateTimePicker',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    type: {
      type: String,
      default: 'datetime'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    pickerOptions: {
      type: Object,
      default: () => ({})
    },
    format:{
      type: String,
      default: 'dd-MM-yyyy HH:mm'
    },
    valueFormat:{
      type: String,
      default: 'yyyy-MM-dd HH:mm'
    },
    placeholder:{
      type: String,
      default: 'dd-MM-yyyy HH:mm'
    },
    defaultTime:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      inputVal: ''
    }
  },
  watch: {
    inputVal: {
      deep: true,
      handler(val) {
        if(val === null && this.type === 'datetimerange') {
          this.inputVal = null
          this.$emit('input', null)
          this.$emit('change', null)
        } else {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    },
    value:{
      immediate: true,
      handler(val){
        this.inputVal = val
      }
    }
  },
  methods: {
    inputValue(dom) {
      if(this.type === 'datetime') {
        let value = dom.target.value
        // console.log(value)
        let str = value.replace(/[^\d]/g, '')
        // console.log(str)
        let len = str.length
        let result = ''
        if (len >= 12) {
          // result = `${str.slice(0, 2)}/${str.slice(2, 4)}/${str.slice(4, 8)} ${str.slice(8, 10)}:${str.slice(10, len)}`

          // yyyy-MM-dd HH:mm
          result = `${str.slice(4, 8)}-${str.slice(2, 4)}-${str.slice(0, 2)} ${str.slice(8, 10)}:${str.slice(10, len)}`

          // dd-MM-yyyy HH:mm
          let userInput = `${str.slice(0, 2)}-${str.slice(2, 4)}-${str.slice(4, 8)} ${str.slice(8, 10)}:${str.slice(10, len)}`
          
          this.inputVal = result

          // 这里显示用户输入的值
          this.$refs['datetimePickerRef'].userInput = userInput
        }
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.i-datetime-picker {
  width: 100%;
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>

